/**
 * Reason-code options for the report filter drawers — one loader for every report page
 * and the scheduled-report editor (docs/DUPLICATION_AUDIT.md, B3).
 *
 * Uses the getreasoncodes stored procedure (sp_dev_getCustomReasonCodes), not a direct
 * read of core_reason_codes by campus_id. The direct read misses reasons shared across
 * the corporation (a code defined on one campus with a corporate_id), which events on
 * every campus in that corporation can carry — and which the report procs label by
 * "campus OR corporation". Measured on the sandbox: 15 of 16 campuses had a shared
 * reason the Environmental, Executive and Scheduled drawers could not offer, while
 * Alert Details, Caregiver and Shift (already on the procedure) could.
 *
 * Rows are keyed by cloud_reason_code_id in the drawers; see utils/reasonFilterIds.js
 * for why the selection is expanded to cloud + local ids when sent or stored.
 */

import { apiFetch } from '../services/api.js';

/** Filters events with no reason (reason_id 0 / NULL). Not a database row. */
export const NO_REASON_OPTION = { reason_code_id: 0, cloud_reason_code_id: 0, reason_code_description: 'No Reason' };

/**
 * @param {number} campusId
 * @param {{ includeNoReason?: boolean }} [opts] — prepend the synthetic "No Reason" row
 *        (default). The Environmental report omits it: its procs cannot filter on it.
 * @returns {Promise<Array>}
 */
export async function fetchReasonCodeOptions(campusId, { includeNoReason = true } = {}) {
  const rows = await apiFetch({
    procedure: 'getreasoncodes',
    reqType: 'stored',
    payload: { campus_id: campusId },
  });
  const list = Array.isArray(rows) ? rows : [];
  return includeNoReason ? [NO_REASON_OPTION, ...list] : list;
}
